import { api } from "./api";

export const couponsList = async (params: any): Promise<any> => {
  const { data } = await api.get("/cupons", { params });
  return data;
};

export const couponRegister = async (body: {
  code: string;
  discount: number | string;
  type: string;
  firstMonthlyPayment: string;
  discountType: string;
}): Promise<any> => {
  const { data } = await api.post("cupons/register", body);
  return data;
};

export const assignCoupon = async (body: unknown): Promise<any> => {
  const { data } = await api.post("cupons/assign", body);
  return data;
};

export const couponUpdate = async (body: {
  id: string;
  code: string;
  discount: number;
  type: string;
  firstMonthlyPayment: string;
  discountType: string;
}): Promise<any> => {
  const { data } = await api.put("cupons/update", body);
  return data;
};

export const couponChangeStatus = async (body: {
  id: string | number;
  statusCupom: string;
}): Promise<any> => {
  const { data } = await api.put("cupons/change", body);
  return data;
};

export const couponDelete = async (id: string | number): Promise<any> => {
  const { data } = await api.delete("cupons/delete/" + id);
  return data;
};

export const checkCupom = async (body: any): Promise<unknown> => {
  const { data } = await api.post("cupons/check", body);
  return data;
};
